/*
 * @author BSG <dev@bsgroup.eu>
 * @copyright Better Software Group S.A.
 * @version: 1.0
 */

import cx from "classnames";
import { useTranslation } from "next-i18next";

import { Input } from "components";
import { useSearchInputLogic } from "./useSearchInputLogic";

import ClearIcon from "resources/icons/x.svg";
import { SearchButton } from "./SearchButton";

import styles from "./SearchInput.module.scss";

export interface ISearchInputProps {
  isTabletDown?: boolean;
  className?: string;
}

export type SearchParams = {
  query: string;
  person?: string;
  language?: string;
};

export const SearchInput = ({ className }: ISearchInputProps) => {
  const { t } = useTranslation("translations");
  const {
    inputRef,
    searchPhrase,
    isInputExpanded,
    expandInput,
    handleClear,
    handleInputChange,
  } = useSearchInputLogic({ withExpand: true });

  return (
    <div
      className={cx(
        styles.searchContainer,
        {
          [styles.expanded]: isInputExpanded,
        },
        [className]
      )}
    >
      <SearchButton onClick={expandInput} />

      {isInputExpanded && (
        <>
          <Input
            ref={inputRef}
            type="text"
            value={searchPhrase}
            placeholder={t("web_search_input_field")}
            spellCheck={false}
            autoFocus={true}
            className={styles.inputContainer}
            inputClassName={styles.input}
            onChange={handleInputChange}
          />
          <button className={styles.clear} onClick={handleClear}>
            <ClearIcon />
          </button>
        </>
      )}
    </div>
  );
};

export default SearchInput;
